import {Toaster} from "sonner";
import {ADMIN_TOASTER_ID} from "@/lib/adminToast";

/** Bottom-right admin toasts (success / error / info). Click toast or × to dismiss; auto-hides. */
export function AdminToaster() {
  return (
    <Toaster
      id={ADMIN_TOASTER_ID}
      theme="system"
      position="bottom-right"
      richColors
      closeButton
      expand
      visibleToasts={5}
      duration={4500}
      offset={20}
      className="admin-toaster"
      toastOptions={{
        classNames: {
          toast: "admin-toast",
          title: "admin-toast__title",
          description: "admin-toast__desc",
          closeButton: "admin-toast__close",
          success: "admin-toast--success",
          error: "admin-toast--error",
          info: "admin-toast--info",
          warning: "admin-toast--warning"
        }
      }}
    />
  );
}
